import { Button, Hint, Input, Label } from 'components';
import { GithubRepo } from 'gql/graphql';
import { toaster } from 'helpers/toaster';
import { useTranslations } from 'next-intl';
import { useGithubData } from 'providers/IntegrationsProvider/useGithubData';
import { useGithubRepoUpdate } from 'providers/IntegrationsProvider/useGithubRepoUpdate';
import { ChangeEvent, FC, FormEvent, useState } from 'react';
import { notifyException } from 'services/appsignal';
import { useGithubContext } from '../_context/GithubContext';

interface IEditRepository {
  repository: GithubRepo;
}

const EditRepository: FC<IEditRepository> = ({ repository }) => {
  const { refetch } = useGithubData();
  const { setEditId } = useGithubContext();
  const t = useTranslations();
  const { mutateAsync: githubRepoUpdate } = useGithubRepoUpdate({
    onSuccess: () => toaster.success(t('messages.success.updating_repo')),
    onError: (error: unknown) => {
      notifyException(error);
      toaster.error(t('messages.error.updating_repo'));
    }
  });

  const [repoName, setRepositoryName] = useState(repository?.repoName);
  const [personalToken, setPersonalToken] = useState(repository?.personalToken);

  const handlerRepositoryToDefault = () => setEditId('');

  const updateRepositoryName = (e: ChangeEvent<HTMLInputElement>) =>
    setRepositoryName(e.target.value);

  const updatePersonalToken = (e: ChangeEvent<HTMLInputElement>) =>
    setPersonalToken(e.target.value);

  const sendRepositoryUpdates = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    await githubRepoUpdate({
      repoId: repository.id,
      repoName: repoName,
      personalToken
    });
    refetch();
    handlerRepositoryToDefault();
  };

  const disabled =
    !repository?.id ||
    !repoName ||
    !personalToken ||
    (repoName === repository.repoName && !personalToken);

  return (
    <form className="github__sidebox" onSubmit={sendRepositoryUpdates}>
      <span className="githhub__sidebox__logo ticon-github"></span>
      <span
        className="github__sidebox__close ticon-cancel"
        onClick={handlerRepositoryToDefault}
      ></span>
      <Label>{t('integrations.github.repository')}</Label>
      <Input
        id={`repository-name-input-${repository?.id}`}
        type="text"
        value={repoName || ''}
        onChange={updateRepositoryName}
      />
      <Label>{t('integrations.github.personal_token')}</Label>
      <Input
        id={`personal-token-input-${repository?.id}`}
        type="text"
        value={personalToken || ''}
        onChange={updatePersonalToken}
      />
      <Hint>{t('integrations.github.token_encryption')}</Hint>
      <div className="mt-4 flex justify-center">
        <Button size="medium" disabled={disabled}>
          {t('integrations.github.update_data')}
        </Button>
      </div>
    </form>
  );
};

export default EditRepository;
